<p-select
  [options]="options()"
  [multiple]="true"
  [ngModel]="selected()"
  (ngModelChange)="selectionChange.emit($event ?? [])"
  panelStyleClass="p-select-checkbox-options"
  [placeholder]="placeholder()"
>
  <ng-template #item let-option>
    <p-checkbox
      [ngModel]="isSelected(option.value)"
      [binary]="true"
      [readonly]="true"
      [tabindex]="-1"
    />
    <span>{{ option.label }}</span>
  </ng-template>

  <ng-template #selectedItem>
    <app-selected-chips
      [items]="selected()"
      [label]="chipLabel"
      [removable]="true"
      (removeItem)="remove($event)"
    />
  </ng-template>
</p-select>
